<div class="modal-header">
    <button type="button" class="btn-close" (click)="bsModalRef.hide()" aria-label="Close"><i class="feather x"></i></button>
    <h4 class="modal-title" id="myModalLabel">Notifications</h4>
</div>
<div class="modal-body">
    <form>
        <label style="display:flex;cursor: pointer;font-weight: normal">
            <div class="checkbox-wrapper" style="padding-right:10px;">
                <input type="checkbox" checked name="email_notificaions" id="" [(ngModel)]="_conversation.options.is_email_enabled">
            </div>
            <div class="text-wrapper" style="flex-grow:1">
                <h4>Email notifications</h4>
                <p>Receive emails with unread messages <strong>from this conversation</strong>.</p>
            </div>
        </label>
    </form>
</div>
<div class="modal-footer">
    <div class="row">
        <div class="col-sm-6 text-left">
            <button type="button" class="btn btn-default" (click)="bsModalRef.hide()">Cancel</button>
        </div>
        <div class="col-sm-6">
            <button type="button"  class="btn btn-primary" (click)="saveNotificationSettings()">Save</button>
        </div>
    </div>
</div>